module.exports = __webpack_public_path__ + "assets/311e2079f967f7ca9ab6a905442fac6c.mp3";